<template>
  <div class="app-container view-container bj-label-colon">
    <!-- 订单基本信息 -->
    <BjDivider right-fixed>{{ $t('orderNewPatch.Information') }}
      <template slot="right">
        <template v-if="!isView">
          <el-button @click="tryCancel">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" @click="onConfirm">{{ $t('saveText') }}</el-button>
        </template>
        <template v-if="isView">
          <el-button type="primary" @click="cancel">{{ $t('backText') }}</el-button>
        </template>
      </template>
    </BjDivider>
    <el-form ref="form" :model="form" label-position="top" :rules="rules" label-width="160px">
      <el-row>
        <el-col :span="colSpan">
          <el-form-item :label="$t('orderNewPatch.CustomerOrder')" prop="orderBaseInfoDTO.outerOrderNo">
            <BjInput v-model="form.orderBaseInfoDTO.outerOrderNo" disabled :maxlength="MAX_LENGTH.DEFAULT" show-word-limit />
          </el-form-item>
        </el-col>
        <BjSelectChannelStore :span="colSpan" disabled :query-params="form.orderBaseInfoDTO" :query-keys="['channel', 'storeCode']" :query-props="['orderBaseInfoDTO.channel', 'orderBaseInfoDTO.storeCode']" :query-labels="[$t('SalesOrderEntry.channel'), $t('SalesOrderEntry.store')]" store-option-value="code" @handleStoreChange="onChangeStore" />
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseOrder2.means')" prop="orderBaseInfoDTO.shippingMethod">
            <BjSelectLov v-model="form.orderBaseInfoDTO.shippingMethod" :option-list="CSG_ORDER_SHIPPING_METHODS_LIST" @change="onChangeShippingMethod"/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('orderNewPatch.Ordered')" prop="orderBaseInfoDTO.orderTime">
            <BjDateTimerPicker v-model="form.orderBaseInfoDTO.orderTime" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SalesOrderEntry.Notes')" prop="orderBaseInfoDTO.orderRemarks">
            <el-input v-model="form.orderBaseInfoDTO.orderRemarks" :maxlength="MAX_LENGTH.PRIORITY" type="textarea" show-word-limit autosize :placeholder="$t('SalesOrderEntry.Notes')" />
          </el-form-item>
        </el-col>
        <!-- 'CSG MANUAL' 审核报价 -->
        <el-col v-if="isCSGShow" :span="colSpan/2">
          <el-form-item :label="$t('WarehouseManagement.form.isQuotation')" prop="isQuota">
            <el-switch v-model="isQuota" active-color="#082dc3" inactive-color=""></el-switch>
          </el-form-item>
        </el-col>
        <!-- 'CSG MANUAL' 是否指定物流 -->
        <el-col v-if="isCSGShow" :span="colSpan/2">
          <el-form-item :label="$t('WarehouseManagement.form.isLogisticsSpecified')">
            <el-switch v-model="isLogisticsSpecified" disabled active-color="#082dc3" inactive-color=""></el-switch>
          </el-form-item>
        </el-col>
        <!-- 'CSG MANUAL' 物流信息 -->
        <el-col v-if="isLogisticsSpecified" :span="colSpan">
          <el-form-item :label="$t('WarehouseManagement.form.chooseLogistics')" prop="LogisticsSelectionDataRule">
            <BjSelectLov v-model="form.orderBaseInfoDTO.logisticsBusinessName" :option-list="LogisticsSelectionData" @change="logsome" />
          </el-form-item>
        </el-col>
        <!-- 'CSG MANUAL' 送货预约时间 -->
        <el-col v-if="isCSGShow" :span="colSpan">
          <el-form-item :label="$t('BusinessThirdOrderAdd.deliveryAppointmentTime')">
            <BjDateTimerPicker v-model="form.orderBaseInfoDTO.deliveryAppointmentTime" />
          </el-form-item>
        </el-col>
        <!-- 'CUSTOMER MANUAL' -->
        <template v-if="isCustomerShow">
          <el-col :span="colSpan">
            <el-form-item :label="$t('WarehouseManagement.form.chooseLogistics')">
              <BjSelectLov v-model="form.orderBaseInfoDTO.logisticsBusinessName" :option-list="LogisticsSelectionData" @change="logsome" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('OrdinaryOrderMix.LogisticsTable.logisticsNo')" prop="orderBaseInfoDTO.logisticsNo">
              <BjInput v-model="form.orderBaseInfoDTO.logisticsNo" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('WarehouseManagement.form.need')" prop="palletQty">
              <BjInputNumber v-model="form.orderBaseInfoDTO.palletQty" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('WarehouseManagement.form.time')" prop="truckPickupTime">
              <BjDateTimerPicker v-model="form.orderBaseInfoDTO.truckPickupTime" />
            </el-form-item>
          </el-col>
          <!-- 'CUSTOMER MANUAL' 是否需要仓库提供尺寸信息 -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('WarehouseManagement.form.check')" prop="isProvideSize">
              <el-switch v-model="form.orderBaseInfoDTO.isProvideSize" active-color="#082dc3" inactive-color=""></el-switch>
            </el-form-item>
          </el-col>
        </template>
      </el-row>
      <el-row>
        <template>
          <!-- 物流单：只有CUSTOMER MANUAL才有 -->
          <!-- shippingLabels -->
          <el-col :span="colSpan" v-show="isCustomerShow">
            <el-form-item :label="$t('OrdinaryOrderMix.LogisticsTable.Shipment')">
              <UploadFile ref="UploadFileRef1" class="avatar-uploader" :limit="20" :limit-size="5 * 1024" multiple show-file-list accept="image/png,image/jpeg,.csv,.pdf,.doc,.docx,.xlsx" :accept-list="['image/jpeg', 'image/png', '.csv', '.pdf', '.doc', '.xlsx']" auto-upload limit-hide @handleFileListChange="fileListChange1">
                <template slot="default">
                  <el-button size="small" type="primary">{{ $t('BusinessImportHistory.page.SelectFile') }}</el-button>
                </template>
                <template slot="tip">
                  <div class="hint">
                    <p> 1.{{$t('OrdinaryOrderMix.LogisticsTable.ps1')}}</p>
                    <p> 2.{{$t('OrdinaryOrderMix.LogisticsTable.ps2')}}</p>
                  </div>
                </template>
              </UploadFile>
            </el-form-item>
          </el-col>
          <!-- 附件 -->
          <!-- orderMaterialList -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('OrdinaryOrderMix.LogisticsTable.Supporting')">
              <UploadFile :disabled="!$store.getters.cusId" ref="UploadFileRef2" class="avatar-uploader" :limit="20" :limit-size="5 * 1024" multiple show-file-list accept="image/png,image/jpeg,.csv,.pdf,.doc,.docx,.xlsx" :accept-list="['image/jpeg', 'image/png', '.csv', '.pdf', '.doc', '.xlsx']" auto-upload limit-hide @handleFileListChange="fileListChange2">
                <template slot="default">
                  <el-button :disabled="!$store.getters.cusId" size="small" type="primary">{{ $t('BusinessImportHistory.page.SelectFile') }}</el-button>
                </template>
                <template slot="tip">
                  <div class="hint">
                    <p> 1.{{$t('OrdinaryOrderMix.LogisticsTable.ps3')}}</p>
                  </div>
                </template>
              </UploadFile>
            </el-form-item>
          </el-col>
        </template>
      </el-row>

      <!-- 收货人信息 -->
      <BjDivider>{{ $t('orderNewPatch.Receiver') }}</BjDivider>
      <el-row>
        <!-- 收货人 -->
        <el-col v-if="!cptIsPickSelf" :span="colSpan">
          <el-form-item :label="$t('SalesOrderEntry.Consignee')" prop="orderBuyerInfoDTO.receiverName">
            <BjInput v-model="form.orderBuyerInfoDTO.receiverName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
          </el-form-item>
        </el-col>
        <!-- 收货人手机号 -->
        <el-col :span="colSpan">
          <el-form-item :label="cptIsPickSelf ? $t('SalesOrderEntry.phone') : $t('SalesOrderEntry.mobile')" prop="orderBuyerInfoDTO.deliveryPhone">
            <BjInput v-model="form.orderBuyerInfoDTO.deliveryPhone" onkeyup="this.value = this.value.replace(/[^\d]/g,'');" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
          </el-form-item>
        </el-col>
        <!-- 邮箱 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('ExternalOrders.newAdd.emailAddress')" prop="orderBuyerInfoDTO.deliveryEmailAddress" :rules="{ required:false, validator: this.validatorEmail, trigger: 'blur'}">
            <BjInput v-model="form.orderBuyerInfoDTO.deliveryEmailAddress" :maxlength="MAX_LENGTH.NORMAL_REMARK" :placeholder="$t('inputText')" />
          </el-form-item>
        </el-col>
        <!-- 国家 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('WarehouseManagement.form.country')" prop="orderBuyerInfoDTO.country" :rules="{ required:true, message: this.$t('chooseText'), trigger: 'change'}">
            <BjSelectLov v-model="form.orderBuyerInfoDTO.country" :option-list="COUNTRY_NAME_AND_TWOCODE" :placeholder="$t('chooseText')" />
          </el-form-item>
        </el-col>
        <!-- 洲 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('WarehouseManagement.form.state')" prop="orderBuyerInfoDTO.province" :rules="{ required:false, message: this.$t('inputText'), trigger: 'blur'}" v-if="form.orderBaseInfoDTO.shippingMethod=='PICKUP' || ['TW','HK','MO','SG','GB','IE','IL','IS','AE','MC','BH','VA','SZ','MV','NZ','SM','LI','AD','BS'].includes(form.orderBuyerInfoDTO.country)">
            <BjInput v-model="form.orderBuyerInfoDTO.province" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
          </el-form-item>
          <el-form-item :label="$t('WarehouseManagement.form.state')" prop="orderBuyerInfoDTO.province" :rules="{ required: true, validator: this.validatorAddress1, trigger: 'blur'}" v-else>
            <BjInput v-model="form.orderBuyerInfoDTO.province" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
          </el-form-item>
        </el-col>
        <!-- 郊区 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('WarehouseManagement.form.city')" prop="orderBuyerInfoDTO.district" :rules="{ required:form.orderBaseInfoDTO.shippingMethod=='PICKUP'?false:true, validator: this.validatorAddress1, trigger: 'blur'}">
            <BjInput v-model="form.orderBuyerInfoDTO.district" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
          </el-form-item>
        </el-col>
        <!-- 邮编 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('WarehouseManagement.form.postcode')" prop="orderBuyerInfoDTO.zipCode" :rules="{ required:form.orderBaseInfoDTO.shippingMethod=='PICKUP'?false:true, validator: this.validatorPostCode, trigger: 'blur'}">
            <BjInput v-model="form.orderBuyerInfoDTO.zipCode" :maxlength="MAX_LENGTH.SHORT_NAME" :placeholder="$t('inputText')" />
          </el-form-item>
        </el-col>
        <!-- 邮寄地址1 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('ExternalOrders.newAdd.DeliveryAddress1')" prop="orderBuyerInfoDTO.deliveryAddress1" :rules="{ required:form.orderBaseInfoDTO.shippingMethod=='PICKUP'?false:true, validator: this.validatorAddress1, trigger: 'blur'}">
            <BjInput v-model="form.orderBuyerInfoDTO.deliveryAddress1" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
          </el-form-item>
        </el-col>
        <!-- 邮寄地址2 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('ExternalOrders.newAdd.DeliveryAddress2')" prop="orderBuyerInfoDTO.deliveryAddress2" :rules="{ required:form.orderBaseInfoDTO.shippingMethod=='PICKUP'?false:false, validator: this.validatorAddress2, trigger: 'blur'}">
            <BjInput v-model="form.orderBuyerInfoDTO.deliveryAddress2" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('SalesOrderEntry.address')" clearable />
          </el-form-item>
        </el-col>

        <!-- 收货人备注 -->
        <!-- <el-col :span="colSpan * 2">
            <el-form-item :label="$t('orderNewPatch.ReceiverNotes')" prop="orderBuyerInfoDTO.buyerRemarks">
              <BjTextarea v-model="form.orderBuyerInfoDTO.buyerRemarks" :maxlength="MAX_LENGTH.PRIORITY" :placeholder="$t('orderNewPatch.ReceiverNotes')" />
            </el-form-item>
          </el-col> -->
      </el-row>

      <!-- 商品信息 -->
      <BjDivider>{{ $t('SalesOrderEntry.Product') }}
        <template v-slot:button>
          <el-button :disabled="SELECTED_BJ_EBC_ID.length == 0" type="danger" @click="batchDelete">{{ $t('SalesOrderEntry.delete') }}</el-button>
          <el-button type="primary" @click="addGoodsDialog('dialogListOrdinarySku')">{{ $t('SalesOrderEntry.ordinary') }}</el-button>
          <el-button type="primary" @click="addGoodsDialog('dialogListPackAgeSku')">{{ $t('SalesOrderEntry.package') }}</el-button>
        </template>
      </BjDivider>

      <OrderItemTable ref="OrderItemTable" :disabled="false" :is-show="!$store.getters.cusId" :is-true="false" :table-data.sync="form.orderItemDTOList" @delete="onDelete" @selection-change="handleSelectionChange" />
    </el-form>
    <!-- 选择普通商品 -->
    <BjDialogList ref="dialogListOrdinarySku" width="80%" :config="
            $BjDialogListConfig.skuDefault($t('SalesOrderEntry.goods'), {
              defaultQuery: { setFlag: 0, status: [3, 4, 5] },
            })
          " multiple @confirm="onAddGoodsDialogConfirm" />
    <!-- 选择组合商品 -->
    <BjDialogList ref="dialogListPackAgeSku" width="80%" :config="
            $BjDialogListConfig.skuDefault($t('SalesOrderEntry.Add'), {
              defaultQuery: { setFlag: 1, status: [3, 4, 5] },
            })
          " multiple @confirm="onAddGoodsDialogConfirm" />
  </div>
</template>
<script>
    import viewMiXin from '@/utils/view-mixin.js';
    import { channelApi, afterApi, logisticApi, commonApi, stockApi, orderApi } from '@/api';
    import OrderItemTable from './OrderItemTable';
    import UploadFile from './UploadFile';
    import { randomID, getShippingList } from '@/utils/index';
    import { COUNTRY_NAME_AND_TWOCODE } from '@/utils/statics';
    import moment from 'moment';

    const getDefaultForm = () => {
      return {
        // 订单基础信息
        orderBaseInfoDTO: {
          actionType: '201', // (string, optional): 订单创建类型 , 手工单
          copyOrigin: null, // (string, optional): 复制来源 ,
          businessType: 'common',
          channel: null,
          orderRemarks: null,
          orderTime: new Date(),
          deliveryAppointmentTime: null,
          isProvideSize: false,
          truckPickupTime: null,
          palletQty: null,
          outerOrderNo: null,
          payStatus: 1,
          storeCode: null,
          storeId: null,
          storeName: null,
          salesEmployeeId: null,
          salesEmployeeRealName: null,
          salesOrganizingId: null,
          takingDeliveryStoreId: null,
          takingDeliveryStoreName: null,
          takingDeliveryWay: '2',
          shippingMethod: null,
          shippingLabels: [],
          orderMaterialList: [],
        },
        // 订单买家信息
        orderBuyerInfoDTO: {
          address: null,
          buyerNick: null,
          buyerRemarks: null,
          city: null,
          cityCode: null,
          country: null,
          countryCode: null,
          district: null,
          districtCode: null,
          phone: null,
          deliveryPhone: null,
          province: null,
          provinceCode: null,
          receiverName: null,
          town: null,
          deliveryAddress2: null,
          deliveryAddress1: null,
          deliveryEmailAddress: null,
          zipCode: null,
        },
        // 订单商品详情
        orderItemDTOList: [],
        // 订单支付信息
        orderPaymentInfoDTO: {
          payAmount: null,
          payTime: null,
          payType: null,
          goodsTotalAmount: null, // 订单应收总金额  取计算属性 goodsTotalAmount
          costTotalAmount: null, // 商品总成本  取计算属性 costTotalAmount
          flag: false, // 支付金额是否含运费
          transPrice: null,
        },
        // TODO: 优惠信息
        orderDiscountInfoDTO: {
          flag: false,
          total: null,
          seller: null,
          third: null,
        },
      };
    };
    export default {
      name: 'BusinessOrderInternalAddCSG',
      components: { OrderItemTable, UploadFile },
      mixins: [viewMiXin],
      data() {
        return {
          colSpan: 8,
          COUNTRY_NAME_AND_TWOCODE,
          isRules: false,
          CSG_ORDER_SHIPPING_METHODS_LIST: [],
          form: getDefaultForm(),
          orderDisabledList: [],
          selectedRow: [],
          /** 订单应收总金额 */
          shopTotalPrice: 0,
          // 应收总金额
          receiveTotalPrice: 0,
          onSearch: false,
          isLogisticsSpecified: false,
          // 是否报价
          isQuota: false,
          isCSGShow: false,
          isCustomerShow: false,
          queryApi: logisticApi.getLogisticsCompany,
          LogisticsSelectionData: [],
          // 仓库数据
          WarehousesList: [],
          resultObject: null,
          shippingLabels: [],
          orderMaterialList: [],
        };
      },
      computed: {
        SELECTED_BJ_EBC_ID() {
          return this.selectedRow.map(e => e.BJ_EBC_ID);
        },
        // 表单校验
        rules() {
          const validateLogistics = (rule, value, callback) => {
            this.$nextTick(() => {
              if (this.isLogisticsSpecified && !this.form.orderBaseInfoDTO.logisticsBusinessName) {
                callback(new Error(this.$t('chooseText')));
              }
              callback();
            });
          };
          const validateOuterOrderNo = (rule, value, callback) => {
            this.$nextTick(() => {
              if (!this.form.orderBaseInfoDTO.outerOrderNo) {
                callback(new Error(this.$t('inputText')));
              }
              if(/[^a-zA-Z0-9_#\[\]\(\)\-]/g.test(this.form.orderBaseInfoDTO.outerOrderNo)){
                callback(new Error(this.$t('inputPlusText')));
              }
              callback();
            });
          };
          const validateRemarks = (rule, value, callback) => {
            this.$nextTick(() => {
              // if(/[^a-zA-Z0-9_#\[\]\(\)\-\s]/g.test(this.form.orderBaseInfoDTO.orderRemarks)){
              //   callback(new Error(this.$t('inputPlusText')));
              // }
              callback();
            });
          };

          return {
            'orderBaseInfoDTO.channel': [{ required: true, message: this.$t('SalesOrderEntry.form.channel'), trigger: 'change' }],
            'orderBaseInfoDTO.storeCode': [{ required: true, message: this.$t('SalesOrderEntry.form.store'), trigger: 'change' }],
            'orderBaseInfoDTO.outerOrderNo': [{ required: true, validator: validateOuterOrderNo, trigger: 'blur' }],
            'orderBaseInfoDTO.orderRemarks': [{ required: true, validator: validateRemarks, trigger: 'blur' }],
            'orderBaseInfoDTO.orderTime': [{ required: true, message: this.$t('SalesOrderEntry.form.ordering'), trigger: 'change' }],
            'orderBuyerInfoDTO.receiverName': [{ required: true, message: this.$t('SalesOrderEntry.form.consignee'), trigger: 'blur' }],
            'orderBuyerInfoDTO.deliveryPhone': [{ required: true, message: this.$t('SalesOrderEntry.form.number'), trigger: 'blur' }],
            'orderBaseInfoDTO.shippingMethod': [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
            LogisticsSelectionDataRule: { required: true, validator: validateLogistics, trigger: 'change' },
          };
        },
        cptIsPickSelf() {
          return this.form.orderBaseInfoDTO.takingDeliveryWay == '1';
        },
      },
      watch: {
        /** 是否开启三方平台活动 */
        'form.orderPaymentInfoDTO.flag': {
          handler() {
            this.form.orderPaymentInfoDTO.transPrice = 0.0;
          },
        },
      },
      created() {
        getShippingList(this.$store.getters.cusId).then(res=>{
          this.CSG_ORDER_SHIPPING_METHODS_LIST = res.filter(item=> !item.isDisable)
        })
        // 获取仓库数据
        this.getOnlineShopList();
        this._getListWarehouses();
        this.getDataOfSearch();
        setTimeout(() => {
          // 获取复制订单页信息
          this.getCopyInfo();
        }, 300);
        
      },
      methods: {
        // 邮箱校验  
        validatorEmail(rule, value, callback) {
          if (!value) {
            callback();
          } else if (value && !value.includes('@')){
            callback(new Error(this.$t('personal.emailErrorMsg2')));
          } else {
            callback();
          }
        },
        // 邮编校验  
        validatorPostCode(rule, value, callback) {
          if(this.form.orderBaseInfoDTO.shippingMethod == 'PICKUP'){
            if (value) {
              callback(new Error(this.$t('ExternalOrders.addressTips')));
            } else {
              callback();
            }
          }else{
            if (!value) {
              callback(new Error(this.$t('inputText')));
            } else {
              callback();
            }
          }
        },
        // 地址1校验
        validatorAddress1(rule, value, callback) {
          const regex = /^[A-Za-z0-9 \-\'\.,\/#&:;()]+$/
          if(this.form.orderBaseInfoDTO.shippingMethod == 'PICKUP'){
            if (value) {
              callback(new Error(this.$t('ExternalOrders.addressTips')));
            } else {
              callback();
            }
          }else{
            if (!value) {
              callback(new Error(this.$t('inputText')));
            } else if(!regex.test(value)){
              callback(new Error(this.$t('IncorrectAddressFormatText')));
            } else {
              callback();
            }
          }
        },
        // 地址2校验 ： 非必填，如果填写就要符合规范
        validatorAddress2(rule, value, callback) {
          const regex = /^[A-Za-z0-9 \-\'\.,\/#&:;()]+$/
          if(this.form.orderBaseInfoDTO.shippingMethod == 'PICKUP'){
            if (value) {
              callback(new Error(this.$t('ExternalOrders.addressTips')));
            } else {
              callback();
            }
          }else{
            if (!value) {
              callback();
            } else if (!regex.test(value)){
              callback(new Error(this.$t('IncorrectAddressFormatText')));
            } else {
              callback();
            }
          }
        },
        // 详情接口
        getCopyInfo() {
          orderApi.getThirdOrderDetail({ id: null, outerOrderNo: this.$route.query.code }).then(res => {
            this.form.orderBaseInfoDTO = {
              outerOrderNo : res.orderInfoVO.webReference+'-c',
              orderTime : res.orderInfoVO.orderTime,
              deliveryAppointmentTime : res.orderInfoVO.deliveryAppointmentTime
                ? moment(res.orderInfoVO.deliveryAppointmentTime).format('YYYY-MM-DD HH:mm:ss')
                : null,
              channel : res.orderInfoVO.channel,
              storeCode : res.orderInfoVO.storeCode,
              shippingMethod : res.orderInfoVO.shippingMethod,
              orderRemarks : res.orderInfoVO.orderRemarks,
              logisticsBusinessName : res.orderInfoVO.logisticsBusinessName,
              logisticsNo : res.orderInfoVO.logisticsNo,
              isProvideSize : res.orderInfoVO.isProvideSize,
              palletQty : res.orderInfoVO.palletQty,
              truckPickupTime : res.orderInfoVO.truckPickupTime,
            };
            this.form.orderBuyerInfoDTO = {
              receiverName : res.receiverInfoVO.receiverName,
              deliveryPhone : res.receiverInfoVO.mobile?res.receiverInfoVO.mobile:res.receiverInfoVO.phone,
              deliveryEmailAddress : res.receiverInfoVO.deliveryEmailAddress,
              country : res.receiverInfoVO.country,
              province : res.receiverInfoVO.province,
              district : res.receiverInfoVO.district,
              zipCode : res.receiverInfoVO.zipCode,
              deliveryAddress1 : res.receiverInfoVO.deliveryAddress1,
              deliveryAddress2 : res.receiverInfoVO.deliveryAddress2,
            };
            let arr = []
            let promise = Promise.resolve();
            res.thirdItemVO.forEach(async(jitem) =>{
              promise = promise.then(() => {
                return new Promise(resolve => {
                  orderApi.selectSkuCodeBatch({skuCode: jitem.skuCode,cusId:this.$store.getters.cusId}).then(async resp=>{
                    arr.push({
                      id: jitem.id,
                      BJ_EBC_ID: randomID(),
                      skuName : jitem.innerSkuName,
                      skuCode: jitem.skuCode,
                      standardSkuCode : jitem.standardSkuCode,
                      batchNumList : jitem.spuCode,
                      quantity : jitem.quantity,
                      thirdDiscountAmount : 0,
                      freight : 0,
                      batchNumList: resp.map(item=>{return {
                        value: item.batchNum, label: item.batchNum, usableNum:item.usableNum, bbd:item.bbd
                      }}),
                    });
                    resolve();
                  })
                })
              })
            })
            this.isQuota = res.orderInfoVO.isNeedQuota;
            this.isLogisticsSpecified = res.orderInfoVO.isLogisticsSpecified == 1 ? true : false;
            if(this.form.orderBaseInfoDTO.shippingMethod == 'CUSTOMER MANUAL'){
              // 物流单组件回显
              this.$refs.UploadFileRef1.fileList = JSON.parse(res.orderInfoVO.shippingLabels)
            }
            // 附件组件回显
            this.$refs.UploadFileRef2.fileList = res.orderInfoVO.orderMaterialList?.map(item=>{
              return {
                name: item.fileName,
                url: item.fileUrl
              };
            });
            this.isCSGShow = this.form.orderBaseInfoDTO.shippingMethod == 'CSG MANUAL';
            this.isCustomerShow = this.form.orderBaseInfoDTO.shippingMethod == 'CUSTOMER MANUAL';
            this.getDataOfSearch(this.form.orderBaseInfoDTO.shippingMethod)
            return promise.then(() => {
              this.form.orderItemDTOList = arr;
              this.reSetTable();
            })
          });
        },
        // 获取网店渠道列表
        getOnlineShopList() {
          commonApi.getLovsValue({
            lovCode: 'SCHL.CHANNEL_TYPE',
          }).then(res => {
            const shopIndex = res.filter(item => item.meaning == 'ManualImport')[0].value;
            this.form.orderBaseInfoDTO.channel = shopIndex;
            channelApi.getAllShopPage({
              channelTypeCode: shopIndex,
              page: 0,
              size: 999
            }).then(resp => {
              this.form.orderBaseInfoDTO.storeCode = resp.content[0]?.code;
            });
          });
        },
        onChangeShippingMethod(val) {
          // 清空物流单组件数据
          this.$refs['UploadFileRef1'].fileList = [];
          // 清空物流单参数数据
          this.shippingLabels = [];
          // 清空附件组件数据
          this.$refs['UploadFileRef2'].fileList = [];
          // 清空附件参数数据
          this.orderMaterialList = [];

          this.form.orderBaseInfoDTO.logisticsBusinessName = null;
          this.form.orderBaseInfoDTO.logisticsNo = null;
          this.form.orderBaseInfoDTO.logisticsCompany = null;
          this.form.orderBaseInfoDTO.deliveryAppointmentTime = null;
          this.isCSGShow = false;
          this.logisticsName = null;
          this.isLogisticsSpecified = false;
          this.form.orderBaseInfoDTO.takingDeliveryWay = '1';
          this.isCustomerShow = false;
          this.form.orderBaseInfoDTO.buyerRemarks = '';
          if (val === 'CSG MANUAL') {
            this.form.orderBaseInfoDTO.buyerRemarks = 'CSG manual booking';
            this.isCSGShow = true;
            this.isLogisticsSpecified = true;
          } else if (val === 'CUSTOMER MANUAL') {
            this.form.orderBaseInfoDTO.buyerRemarks = 'Shipping label print';
            this.isCustomerShow = true;
          } else if (val === 'PICKUP') {
            this.form.orderBaseInfoDTO.takingDeliveryWay = '1';
          } else {
            this.form.orderBaseInfoDTO.takingDeliveryWay = '2';
          }
          this.getDataOfSearch(val)
        },
        // 上传的文件列表
        fileListChange1(file) {
          if(file.length > 0){
            this.shippingLabels = file&&file.map(item => { return {name: item.name,  url: item.url}}).filter(item => item.url);
          }else{
            this.shippingLabels = []
          }
        },
        // 上传的文件列表 
        fileListChange2(file) {
          if(file.length > 0){
            this.orderMaterialList = file&&file.map(item => { return {fileName: item.name,  fileUrl: item.url}}).filter(item => item.fileUrl);
          }else{
            this.orderMaterialList = []
          }
        },
        // 获取网店详情
        getOnlineShop(e) {
          channelApi.getOnlineShopDetails({ id: e }).then(res => {
            if (res.shippingCostAutoStatus) {
              this.isRules = false;
            } else {
              this.isRules = true;
            }
          });
        },
        // 获取仓库数据
        _getListWarehouses() {
          commonApi.getListWarehouses({
            code: null,
            name: null,
            typeCode: null,
            status: 1,
          }).then(res => {
            this.WarehousesList = Array.isArray(res) ? res : [];
            function search(nameKey, myArray) {
              for (var i = 0; i < myArray.length; i++) {
                if (myArray[i].name === nameKey) {
                  return myArray[i].id;
                }
              }
            }
            var a = this.WarehousesList;
            this.resultObject = search('实仓', a);
          });
        },
        _getGoodsStockPage(value) {
          // eslint-disable-next-line no-async-promise-executor
          return new Promise(async (resolve, reject) => {
            const res = await stockApi.getGoodsStockPage({
              total: 1,
              currentPage: 0,
              page: 0,
              pageSize: 20,
              size: 20,
              warehouseId: [this.resultObject],
              skuCode: value
            });
            resolve(res?.content?.[0]?.stockNum);
          });
        },

        logsome(v, item) {
          this.form.orderBaseInfoDTO.logisticsCompany = v ? item.label: '';
        },
        // 获取物流下拉信息
        async getDataOfSearch(val) {
          logisticApi.getLogisticsBusiness({
            name: null,
            companyId: null,
            enableFlag: null,
            csgEnableFlag: val=='CSG MANUAL' ? true: null,
            currentPage: 0,
            page: 0,
            pagesize: 999,
            size: 999,
          }).then(res => {
            this.LogisticsSelectionData = res.content.map(item => {
              return { label: item.logisticsName, value: item.name };
            });
          });
        },
        reSetTable() {
          this.$nextTick(() => {
            this.$refs.OrderItemTable.reFresh();
          });
        },
        // 选择收件地址
        onChangeRegionCascader(v) {
          if (v.length) {
            this.form.orderBuyerInfoDTO.country = v[0].label;
            this.form.orderBuyerInfoDTO.countryCode = v[0].value;
            this.form.orderBuyerInfoDTO.province = v[1].label;
            this.form.orderBuyerInfoDTO.provinceCode = v[1].value;
          }
        },
        onChangeStore(v, item) {
          this.form.orderBaseInfoDTO.storeId = item.id;
          this.form.orderBaseInfoDTO.storeName = item.name;

          this.form.orderBaseInfoDTO.salesEmployeeId = null;
          this.form.orderBaseInfoDTO.salesEmployeeRealName = null;

          this.form.orderBaseInfoDTO.takingDeliveryStoreId = null;
          this.form.orderBaseInfoDTO.takingDeliveryStoreName = null;

          this.form.orderBaseInfoDTO.salesOrganizingId = item.salesOrganizingId;
        },
        onChangeSalesEmployee(v, item) {
          this.form.orderBaseInfoDTO.salesEmployeeId = item.id;
          this.form.orderBaseInfoDTO.salesEmployeeRealName = item.realName;
        },
        handleDeliveryStoreChange(v, item) {
          this.form.orderBaseInfoDTO.takingDeliveryStoreId = item.id;
          this.form.orderBaseInfoDTO.takingDeliveryStoreName = item.name;
        },
        batchDelete() {
          this.$confirm(this.$t('SalesOrderEntry.form.sure'), this.$t('toast.hintText'), {
            confirmButtonText: this.$t('toast.okText'),
            cancelButtonText: this.$t('toast.cancelText'),
            type: 'warning',
          }).then(() => {
            this.SELECTED_BJ_EBC_ID.forEach(BJ_EBC_ID => {
              const index = this.form.orderItemDTOList.findIndex(e => e.BJ_EBC_ID == BJ_EBC_ID);
              if (index > -1) this.form.orderItemDTOList.splice(index, 1);
            });
            this.msgSuccess(this.$t('SalesOrderEntry.form.succeeded'));
            this.reSetTable();
          });
        },
        onDelete(row) {
          this.$confirm(this.$t('SalesOrderEntry.form.want'), this.$t('toast.hintText'), {
            confirmButtonText: this.$t('toast.okText'),
            cancelButtonText: this.$t('toast.cancelText'),
            type: 'warning',
          }).then(() => {
            const index = this.form.orderItemDTOList.findIndex(e => e.BJ_EBC_ID == row.BJ_EBC_ID);
            if (index > -1) this.form.orderItemDTOList.splice(index, 1);
            this.msgSuccess(this.$t('SalesOrderEntry.form.succeeded'));
            this.reSetTable();
          });
        },
        handleSelectionChange(d) {
          this.selectedRow = [].concat(d.selection);
        },
        addGoodsDialog(REF_NAME = 'dialogListOrdinarySku') {
          // TODO: 校验 ？ 赠品之类的
          this.orderDisabledList = this.form.orderItemDTOList
            .filter(e => e.giftFlag == 0)
            .map(e => e.id);
          this.$refs[REF_NAME].show();
        },
        onAddGoodsDialogConfirm(data) {
          if (data && !data[0].id) return;
          let promise = Promise.resolve();
          data.forEach(async(item) => {
            // if (!this.form.orderItemDTOList.find(ee => ee.skuCode == item.skuCode)) {
              const SALES_PRICE = Number(item.salesPrice || 0);
              const CONST_PRICE = Number(item.costPrice || 0);
              promise = promise.then(() => {
                return new Promise(resolve => {
                  orderApi.selectSkuCodeBatch({skuCode: item.skuCode,cusId:this.$store.getters.cusId}).then(async resp=>{
                    this.form.orderItemDTOList.push({
                      id: item.id,
                      freight: 0,
                      skuCode: item.skuCode,
                      skuName: item.skuName,
                      spuCode: item.spuCode,
                      spuName: item.spuName,
                      standardSkuCode: item.standardSkuCode,
                      giftFlag: '0',
                      setMealFlag: item.setFlag,
                      outerSingleSaleAmount: 0,
                      outerSaleAmount: this.$number2money(SALES_PRICE * 1),
                      innerSingleSaleAmount: this.$number2money(SALES_PRICE),
                      innerSaleAmount: this.$number2money(SALES_PRICE * 1),
                      transPrice: '0.00',
                      costPrice: this.$number2money(CONST_PRICE * 1),
                      quantity: 1,
                      skuId: item.id,
                      BJ_EBC_ID: randomID(),
                      BJ_HAS_CHILD: !!item.setFlag,
                      BJ_PARENT_ID: null,
                      isChildSku: false,
                      stockNum: await this._getGoodsStockPage(item.skuCode) || 0,
                      batchNumList: resp.map(item=>{return {
                        value: item.batchNum, label: item.batchNum, usableNum:item.usableNum, bbd:item.bbd
                      }}),
                    });
                    resolve();
                  })
                })
              })
            // }
          });
          return promise.then(() => {
            this.reSetTable();
          })
        },
        /** 确定 */
        onConfirm() {
          this.$refs.form.validate(valid => {
            if(valid){
              
              if (this.form.orderItemDTOList.length == 0) {
                this.$message.error(this.$t('BusinessPurchaseOrder2.dialog.errMsg4'));
                return;
              }
              if (this.form.orderItemDTOList.some(e => e.quantity==0)) {
                this.$message.warning(this.$t('SalesOrderEntry.form.Qty'));
                return;
              }
              // if(this.form.orderBaseInfoDTO.shippingMethod == 'CUSTOMER MANUAL'){
              //   if(this.form.orderBaseInfoDTO.logisticsNo && !this.form.orderBaseInfoDTO.logisticsBusinessName) return this.$message.error(this.$t('BusinessPurchaseComponentsCom.rules.logisticsBusinessId'));
              //   if(this.fileList.length>0 && !this.form.orderBaseInfoDTO.logisticsBusinessName) return this.$message.error(this.$t('BusinessPurchaseComponentsCom.rules.logisticsBusinessId'));
              //   if(this.fileList.length>0 && this.form.orderBaseInfoDTO.isProvideSize == true){this.form.orderBaseInfoDTO.isProvideSize = false};
              // }

              // 新CUSTOMER MANUAL逻辑
              if(this.form.orderBaseInfoDTO.shippingMethod == 'CUSTOMER MANUAL'){
                // 若不需要仓库提供尺寸信息 则此处 Courier Service，Job Id/Tracking No.，Shipping Label都应为必填
                if(this.form.orderBaseInfoDTO.isProvideSize == false){
                  if(!this.form.orderBaseInfoDTO.logisticsBusinessName){
                    return this.$message.error(`${this.$t('inputText')} ： ${this.$t('WarehouseManagement.form.chooseLogistics')}`);
                  }
                  if(!this.form.orderBaseInfoDTO.logisticsNo){
                    return this.$message.error(`${this.$t('inputText')} ： ${this.$t('OrdinaryOrderMix.LogisticsTable.logisticsNo')}`);
                  }
                  if(this.shippingLabels.length==0){
                    return this.$message.error(`${this.$t('chooseText')} ： ${this.$t('OrdinaryOrderMix.LogisticsTable.Shipment')}`);
                  }
                }
                // 如果Courier Service，Job Id/Tracking No.，Shipping Label任意一个有值，那么另外两个都必填
                if(this.form.orderBaseInfoDTO.logisticsBusinessName || this.form.orderBaseInfoDTO.logisticsNo || this.shippingLabels.length!=0){
                  if(!this.form.orderBaseInfoDTO.logisticsBusinessName){
                    return this.$message.error(`${this.$t('inputText')} ： ${this.$t('WarehouseManagement.form.chooseLogistics')}`);
                  }
                  if(!this.form.orderBaseInfoDTO.logisticsNo){
                    return this.$message.error(`${this.$t('inputText')} ： ${this.$t('OrdinaryOrderMix.LogisticsTable.logisticsNo')}`);
                  }
                  if(this.shippingLabels.length==0){
                    return this.$message.error(`${this.$t('chooseText')} ： ${this.$t('OrdinaryOrderMix.LogisticsTable.Shipment')}`);
                  }
                }
                // 老逻辑保留
                if(this.shippingLabels.length>0 && this.form.orderBaseInfoDTO.isProvideSize == true){this.form.orderBaseInfoDTO.isProvideSize = false};
              }
            
              const POST_DATA = this.$lodash.clone(this.form);
              // 自提，清空配送信息
              if (this.cptIsPickSelf) {
                POST_DATA.orderBuyerInfoDTO.address = null;
                POST_DATA.orderBuyerInfoDTO.provinceCode = null;
                POST_DATA.orderBuyerInfoDTO.cityCode = null;
                POST_DATA.orderBuyerInfoDTO.districtCode = null;
                POST_DATA.orderBuyerInfoDTO.province = null;
                POST_DATA.orderBuyerInfoDTO.city = null;
                POST_DATA.orderBuyerInfoDTO.district = null;
              }


              // let bstop = true
              const duplicates = new Map();
              const newArr = [];
              POST_DATA.orderItemDTOList.forEach(item=>{
                const key = `${item.standardSkuCode}-${item.spuCode}`;
                if (duplicates.has(key)) {
                    newArr.push(item);
                } else {
                    duplicates.set(key, true);
                }
                // if(item.spuCode && item.quantity > item.batchNumList.bjGet(item.spuCode, 'value', 'usableNum')){
                //   bstop = false
                // };
              })
              // 数据重复
              if(newArr.length > 0) return this.$message.warning(`${newArr[0].standardSkuCode} ${this.$t('dataDuplication')}`)
              // if(!bstop) this.$message.error('Quantity > Available')
              POST_DATA.orderItemDTOList = POST_DATA.orderItemDTOList.map(e => {
                return {
                  giftFlag: e.giftFlag, // (integer, optional): 是否赠品 ,   0 不是赠品  1 是赠品
                  setMealFlag: e.setMealFlag,
                  outerSaleAmount: e.outerSaleAmount, // (number, optional): 外部销售总价  ,
                  outerSingleSaleAmount: e.outerSingleSaleAmount,
                  innerSingleSaleAmount: e.innerSingleSaleAmount,
                  innerSaleAmount: e.innerSaleAmount,
                  transPrice: e.transPrice,
                  quantity: e.quantity, // (integer, optional): 数量 ,
                  skuCode: e.skuCode, // (string, optional): sku编码 ,
                  spuCode: e.spuCode, 
                  skuId: e.skuId, // (integer, optional): skuId
                  innerSkuCode: e.skuCode, // 同sku编码

                  outerOrderNo: this.form.orderBaseInfoDTO.outerOrderNo,
                  orderRemarks: this.form.orderBaseInfoDTO.orderRemarks,
                  shippingMethod: this.form.orderBaseInfoDTO.shippingMethod,
                  // 物流单传参
                  shippingLabels: this.shippingLabels.length>0 ? JSON.stringify(this.shippingLabels) : null,
                  // 附件传参
                  orderMaterialList: this.orderMaterialList,
                  orderTime: moment(this.form.orderBaseInfoDTO.orderTime).format('YYYY-MM-DD HH:mm:ss'),
                  deliveryAppointmentTime: this.form.orderBaseInfoDTO.deliveryAppointmentTime ? moment(this.form.orderBaseInfoDTO.deliveryAppointmentTime).format('YYYY-MM-DD HH:mm:ss') : null,
                  truckPickupTime: this.form.orderBaseInfoDTO.truckPickupTime? moment(this.form.orderBaseInfoDTO.truckPickupTime).format('YYYY-MM-DD HH:mm:ss') : null,
                  isProvideSize: this.form.orderBaseInfoDTO.isProvideSize,
                  palletQty: this.form.orderBaseInfoDTO.palletQty,
                  shippingWarehouse: null, // 原始发货仓库
                  goodsQuantity: e.quantity,
                  confirmed: null, // 证明，批准
                  // webReference新增里面传null，复制订单传outerOrderNo
                  webReference: this.form.orderBaseInfoDTO.outerOrderNo,
                  distributionCenterType: null, // 配送中心类型
                  ECommerceOrderRef: null, // 电子商务订单参考
                  siteListingId: null, // 建筑上市Id
                  lineOrderCustomerRef: null, // 订单生产客户编号
                  route: null, // 渠道，路线
                  barCode: null, // 条形码
                  storeCode: this.form.orderBaseInfoDTO.storeCode,
                  orderSource: this.form.orderBaseInfoDTO.orderSource,
                  totalPrice: 0,
                  logisticsNo: this.form.orderBaseInfoDTO.logisticsNo || null,
                  deliveryName: this.form.orderBuyerInfoDTO.receiverName,
                  deliveryPhone: this.form.orderBuyerInfoDTO.deliveryPhone,
                  deliveryAddress1: this.form.orderBuyerInfoDTO.deliveryAddress1,
                  deliveryAddress2: this.form.orderBuyerInfoDTO.deliveryAddress2,
                  deliveryState: this.form.orderBuyerInfoDTO.province,
                  deliveryPostcode: this.form.orderBuyerInfoDTO.zipCode,
                  deliverySuburb: this.form.orderBuyerInfoDTO.district,
                  destCountry: this.form.orderBuyerInfoDTO.country,
                  deliveryEmailAddress: this.form.orderBuyerInfoDTO.deliveryEmailAddress,
                  comments: this.form.orderBuyerInfoDTO.buyerRemarks,
                  buyerRemarks: this.form.orderBuyerInfoDTO.buyerRemarks,
                  isLogisticsSpecified: this.isLogisticsSpecified == true ? '1' : '0',
                  isNeedQuota: this.isQuota == true ? 1 : 0,
                  logisticsName: this.form.orderBaseInfoDTO.logisticsBusinessName,
                  logisticsCompany: this.form.orderBaseInfoDTO.logisticsCompany,
                  logisticsBusinessName: this.form.orderBaseInfoDTO.logisticsBusinessName,
                  shippingType: this.form.orderBuyerInfoDTO.shippingType,
                  unitprice: e.outerSingleSaleAmount,
                  // amount: e.outerSingleSaleAmount * e.quantity,
                  freight: e.freight,
                  actionType: 101
                };
              });
              afterApi.addInternalResendOrder(POST_DATA.orderItemDTOList).then(res => {
                if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
                  this.$message.success(this.$t('SalesOrderEntry.form.Submitted'));
                  setTimeout(() => {
                    this.cancel();
                  }, 1000);
                }
              });
            }
          });
        },
      },
    };
</script>
<style lang="scss" scoped>
.bottom .el-form-item {
  margin-bottom: 0;
}
.price {
  font-size: 16px;
  font-weight: bold;
}
.hint {
  line-height: 15px;
  margin-top: -10px;
  color: #b2b2b2;
}
::v-deep .avatar-uploader .el-upload {
  border: none;
}
</style>
